/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type InterruptTurnRequestBody = {
  /**
   * The assistant whose conversation should stop generating.
   */
  assistantId: string;
  /**
   * The conversation to stop, as returned by sendMessage.
   */
  chatId: string;
};

/** @internal */
export type InterruptTurnRequestBody$Outbound = {
  assistant_id: string;
  chat_id: string;
};

/** @internal */
export const InterruptTurnRequestBody$outboundSchema: z.ZodMiniType<
  InterruptTurnRequestBody$Outbound,
  InterruptTurnRequestBody
> = z.pipe(
  z.object({
    assistantId: z.string(),
    chatId: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      assistantId: "assistant_id",
      chatId: "chat_id",
    });
  }),
);

export function interruptTurnRequestBodyToJSON(
  interruptTurnRequestBody: InterruptTurnRequestBody,
): string {
  return JSON.stringify(
    InterruptTurnRequestBody$outboundSchema.parse(interruptTurnRequestBody),
  );
}
